import { _ } from "~/i18n";
import Tooltip, { ETooltipFlow } from "~/ui/tooltip";
import { node, createPremiumIcon } from "~/util/dom";
import { openPropositionDialog } from "~/util/premium";

function openProposition(circuit) {
	openPropositionDialog(circuit ? "circuitSubtype" : "transportTypePremium");
}

export function createRoutePremiumIconWithTooltip(circuit = false) {
	const premiumIcon = createPremiumIcon();
	const premium = `<a href="">${_("premium.proposition.popup.premium")}</a>`;
	const content = node("p", { innerHTML: _("route.params.premiumFunction", { premium }) });
	const link = content.querySelector("a") as HTMLAnchorElement;

	/* eslint-disable-next-line */
	const tooltip = new Tooltip({
		anchor: premiumIcon,
		trigger: premiumIcon,
		triggerEventType: "pointerenter",
		content,
		arrow: true,
		flow: ETooltipFlow.ARROW_END,
		offset: [0, 0, 2, 0],
		className: "route-params-premium-tooltip",
		hideTimeout: 500,
		width: 208,
	});

	premiumIcon.style.cursor = "pointer";
	premiumIcon.setAttribute("data-log-action", circuit ? "circuitSubtype_premiumPurchase_show" : "transportTypePremium_premiumPurchase_show");
	premiumIcon.addEventListener("click", () => {
		tooltip.hide();

		openProposition(circuit);
	});
	link.setAttribute("data-log-action", circuit ? "circuitSubtype_premiumPurchase_show" : "transportTypePremium_premiumPurchase_show");
	link.addEventListener("click", event => {
		event.stopPropagation();
		event.preventDefault();
		tooltip.hide();

		openProposition(circuit);
	});

	return premiumIcon;
}
